export default __webpack_public_path__ + "static/media/snowshoes_light.cb31dd97.png";